




























































import { Vue, Component, Prop } from "vue-property-decorator";
import { VIPProject } from "@/loader";

@Component
export default class ProjectDetailCard extends Vue {
	@Prop({ type: VIPProject, required: true })
	public item!: VIPProject;

	@Prop({ type: Boolean, default: false })
	public showProject!: boolean;
}
